@if (showOctoberNews) {
  <astral-dialog
    [closeOnBackdrop]="true"
    [open]="true"
    newsEmphasis="urgent"
    [preserveNewsAspectRatio]="true"
    [suspended]="showNewsDismissalConfirmation"
    size="large"
    titleKey="IMPORTANT_NOTICE.OCTOBER_2026.TITLE"
    variant="news"
    (closed)="closeOctoberNews()"
  >
    <picture astralDialogMedia class="system-overview__dialog-news-media">
      <source media="(max-width: 960px)" srcset="assets/image/anvtraff-fastighet-dialog-example.png" />
      <img
        src="assets/image/anvtraff-fastighet-dialog-desktop-example.png"
        [attr.alt]="'IMPORTANT_NOTICE.EVENT_MEDIA_ALT' | translate"
      />
    </picture>
    <span astralDialogNewsBadge>
      <i aria-hidden="true" class="fa-light fa-clock"></i>
      {{ 'IMPORTANT_NOTICE.OCTOBER_2026.AVAILABILITY' | translate }}
    </span>
    <p>{{ 'IMPORTANT_NOTICE.OCTOBER_2026.DESCRIPTION' | translate }}</p>
    <p class="astral-dialog__news-event-details">
      <i aria-hidden="true" class="fa-light fa-calendar"></i> {{ 'IMPORTANT_NOTICE.OCTOBER_2026.EVENT_DETAILS' | translate }}
    </p>
    <astral-button
      astralDialogActions
      astralDialogFeaturedAction
      href="https://www.hogia.se/om-hogia/event-och-utbildningar/hogia-fastighet-anvandartraff"
      icon="arrowRight"
      iconPosition="after"
      labelKey="IMPORTANT_NOTICE.OCTOBER_2026.LINK_LABEL"
      target="_blank"
      type="button"
    ></astral-button>
    <astral-button
      astralDialogActions
      astralDialogDismiss
      labelKey="COMMON.DONT_SHOW_AGAIN_TEXT"
      type="button"
      variant="secondary"
      (click)="requestOctoberNewsDismissal()"
    ></astral-button>
  </astral-dialog>
}

@if (showNewsDismissalConfirmation) {
  <astral-dialog
    [closeOnEscape]="!octoberNewsDismissalSaving"
    [open]="true"
    [showCloseButton]="false"
    titleKey="IMPORTANT_NOTICE.DISMISS_CONFIRMATION_TITLE"
    variant="prompt"
    (closed)="cancelOctoberNewsDismissal()"
  >
    <i astralDialogIcon class="fa-light fa-circle-question"></i>
    <p>{{ 'IMPORTANT_NOTICE.DISMISS_CONFIRMATION_TEXT' | translate }}</p>
    <astral-button
      astralDialogActions
      [disabled]="octoberNewsDismissalSaving"
      labelKey="IMPORTANT_NOTICE.CONFIRM_DISMISS"
      type="button"
      (click)="confirmOctoberNewsDismissal()"
    ></astral-button>
    <astral-button
      astralDialogActions
      [disabled]="octoberNewsDismissalSaving"
      labelKey="CANCEL_BTN"
      type="button"
      variant="secondary"
      (click)="cancelOctoberNewsDismissal()"
    ></astral-button>
  </astral-dialog>
}
